export default {
    methods: {
        isValidHexColor(value) {
            return /^#([0-9A-F]{3}){1,2}$/i.test(value);
        },

        getValidHexColor(value) {
            if (this.isValidHexColor(value)) {
                return value;
            }
            return "#000000"; // Default to black if invalid
        },

        colorStyle(color) {
            const validHex = typeof color === 'string' && this.isValidHexColor(color);
            return {
                backgroundColor: validHex ? color : '#ffffff',
                border: '1px solid #ced4da',
                display: 'inline-block',
                width: '1.5rem',
                height: '1.5rem',
                borderRadius: '0.25rem',
            };
        },
    },
}